import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import config from 'config/index';

const AuthDisabled = () => {
    const { t } = useTranslation('onboarding');

    return (
        <h4 style={{ textAlign: 'center' }}>
            <Trans
                i18nKey="onboarding:authDisabled"
                values={{
                    link: `https://${config.APP_DOMAIN}`
                }}
                components={{
                    Link: <a href={`https://${config.APP_DOMAIN}`} target="_top" />
                }}
            />
        </h4>
    )
}

export default AuthDisabled;
